



















































import Vue from 'vue'
import Card from '@/ui/card/Card.vue'
import FormInput from '@/ui/input/FormInput.vue'
import PositionDropdown from '@/pages/dictionary/themes/create/parts/position/PositionDropdown.vue'
import Prerequisites from '@/pages/dictionary/themes/create/parts/prerequisites/Prerequisites.vue'
import SubjectsDropdown from '@/pages/common/dropdowns/subject/SubjectsDropdown.vue'
import ClassesDropdown from '@/pages/common/dropdowns/class/ClassesDropdown.vue'
import Themes from '@/pages/dictionary/themes/create/parts/themes/Themes.vue'
import {
  $themeTitle,
  resetThemeTitle,
  themeTitleChanged,
  $themeTitleErrorModule,
  $prerequisiteTitle,
  $prerequisiteTitleErrorModule,
  resetPrerequisiteTitle,
  prerequisiteTitleChanged,
  $positionErrorModule,
  $subjectErrorModule,
  $classErrorModule,
} from '@/pages/dictionary/themes/create/theme-creation-page.model'
import { $isPrerequisite } from '@/pages/dictionary/themes/create/parts/header/header.model'

export default Vue.extend({
  components: {
    Card,
    FormInput,
    PositionDropdown,
    Prerequisites,
    SubjectsDropdown,
    ClassesDropdown,
    Themes,
  },
  effector: {
    $themeTitle,
    $prerequisiteTitle,
    themeTitleError: $themeTitleErrorModule.store.$error,
    prerequisiteTitleError: $prerequisiteTitleErrorModule.store.$error,
    positionError: $positionErrorModule.store.$error,
    subjectError: $subjectErrorModule.store.$error,
    classError: $classErrorModule.store.$error,
    $isPrerequisite,
  },
  methods: {
    resetThemeTitle,
    themeTitleChanged,
    resetPrerequisiteTitle,
    prerequisiteTitleChanged,
  },
})
